import { Backsplash } from '@rta/rta-blueprint-library';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteBacksplashMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete Backsplash',
		isVisible: ({ controller, refMap }): boolean => {
			const { backsplash } = refMap ?? {};
			if (controller.readonly || !backsplash) return false;

			return true;
		},
		onClick: ({ controller, refMap }): void => {
			const backsplash = refMap?.backsplash as Backsplash | null;
			const countertop = refMap?.countertop ?? null;

			if (countertop && backsplash) {
				// Unpair before deleting to clean up any paired backsplash reference
				if (backsplash.isPaired) {
					backsplash.unpair();
				}
				countertop.removeBacksplash(backsplash.id);
			}
		}
	}
};
